import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let ausgaben = context.chart.data.datasets[0].data[context.dataIndex];
                        let saldo = context.chart.data.datasets[1].data[context.dataIndex];
                        let jahr = context.chart.data.labels[context.dataIndex];
                        let einnahmen = ausgaben + saldo;
                        return [
                            'Ausgaben: ' + Math.round(ausgaben) + ' €',
                            'Saldo: ' + Math.round(saldo) + ' €',
                            'Einnahmen: ' + Math.round(einnahmen) + ' €'
                        ];
                    }
                }
            },
            datalabels: {
                anchor: 'center',
                color: function (context) {
                    var value = context.dataset.data[context.dataIndex];
                    return Math.abs(value) > 200 ? '#fff' : tc.datalabelColor;
                },
                align: 'center',
                display: true,
                formatter: Math.round,
                font: {
                    weight: 'normal'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    autoSkip: false,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Jahr',
                    color: tc.textColor
                }
            },
            y: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor,
                    callback: function (value) {
                        return Math.round(value) + ' €';
                    }
                },
                title: {
                    display: true,
                    text: '€',
                    color: tc.textColor
                }
            }
        }
    };
};
